import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { Downtime } from '../../../core/services/times/downtime';
import { AllStatus } from '../../../core/services/status/all-status';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import {MatTabsModule} from '@angular/material/tabs';
import { ExitService } from '../../../core/services/exit/exit.service';
import { DowntimeWindow } from '../../../shared/dialogs/downtime-window/downtime-window';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-step-two',
  imports: [TranslatePipe, MatTabsModule],
  templateUrl: './step-two.html',
  styleUrl: './step-two.scss'
})
export class StepTwo implements OnInit, OnDestroy {
  router = inject(Router);
  downtime = inject(Downtime);
  subscription: Subscription;
  allStatus$ = inject(AllStatus);
  readonly dialog = inject(MatDialog);
  exit = inject(ExitService);

  translate = inject(TranslateService);

  protected selectedTabIndex = 0;
  txtDialog: any;
  subscriptionCL: Subscription;

  ngOnInit(): void {
    this.loadTranslateText();
    this.subscription = this.allStatus$.downTime$.subscribe((follow: any)=>{
      if(follow){
        const dialogConfig = new MatDialogConfig();
        dialogConfig.panelClass = 'nutri-templs';
        dialogConfig.backdropClass = 'nutri-templs-backdrop';
        
        const dialogRef = this.dialog.open(DowntimeWindow, dialogConfig);
        dialogRef.afterClosed().subscribe(result=>{
            this.exit.exitSystem();
        });
      }
    });
    this.subscriptionCL = this.allStatus$.changeLanguage$.subscribe((change: boolean)=>{
      if(change){
        this.allStatus$.setChangeLanguage(false);
        this.loadTranslateText()
      }
    });
  }

  loadTranslateText(){
    this.translate.get(['spinner']).subscribe(translations => {
      this.txtDialog = translations['spinner'];
    });
  }

  ngOnDestroy(): void {
    if(this.subscription){
      this.subscription.unsubscribe();
    }
    if(this.subscriptionCL){
      this.subscriptionCL.unsubscribe();
    }
  }

  goToCreateGame(){
    this.downtime.refreshTimer();
    this.router.navigate(['/create-game', {view: 'many-players'}]);
  }

  goToStepTwo(){
    this.allStatus$.textSpinner = this.txtDialog?.txtLoadingListGame;
    this.allStatus$.setDisplayProgressSpinner(true);
    this.downtime.refreshTimer();
    setTimeout(()=>{
      this.router.navigate(['/games']);
    },750);
    
  }

  goToPrev():void{
    this.downtime.refreshTimer();
    this.router.navigate(['/step-one']);
  }

  goToNextRoom():void{
    if(this.selectedTabIndex){
      this.goToStepTwo();
    }else{
      this.goToCreateGame();
    }
  }

}
